import classNames from 'classnames';
import React from 'react';

import { useSelector } from 'src/store';

export function ProgressBar({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    const { current, max } = useSelector((state) => state.bookingFlow.steps);

    return (
        <div className={classNames('h-1 w-full bg-gray-200', className)} {...props}>
            <div
                style={{ width: `${(current / max) * 100}%` }}
                className="bg-primary-600 h-1 transition-all duration-300"
            />
        </div>
    );
}
